var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ffa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41cad9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 24,
    height: 24,
    transform: "translate(0.239 0.24)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-0.239 -0.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M25.656,1.6a1.6,1.6,0,0,0-1.6-1.6H16.035a1.6,1.6,0,0,0,0,3.207h4.118L14.9,8.486a1.606,1.606,0,1,0,2.271,2.271l5.279-5.27V9.621a1.6,1.6,0,0,0,3.207,0Zm-14.9,13.3a1.59,1.59,0,0,0-2.271,0L3.207,20.153V16.035a1.6,1.6,0,0,0-3.207,0v8.017a1.6,1.6,0,0,0,1.6,1.6H9.621a1.6,1.6,0,0,0,0-3.207H5.486l5.27-5.279a1.59,1.59,0,0,0,0-2.271",
    transform: "translate(-0.455 -0.279)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.24a9b16d847277f6e0a62ec27f643312.svg";
export { ForwardRef as ReactComponent };